import LoadingSpinner from './loadingSpinner';

export default LoadingSpinner;
